import Field from './Field'
import Select from './Select'
import SingleSelect from './SingleSelect'
import { DateCheckbox as DATE_CHECKBOX } from '../components/DateCheckbox'
import { SelectCheckbox as SELECT_CHECKBOX } from '../components/SelectCheckbox'
import { RichTextEditor as RICH_TEXT_EDITOR } from '../components/RichTextEditor'
import { default as CHECKBOX } from '@material-ui/core/Checkbox'
import { default as ASYNC } from 'react-select/async'
import { KeyboardDatePicker } from '@material-ui/pickers'
import { FileUploadCheckbox as FILE_UPLOAD_CHECKBOX } from '../components/FileUploadCheckbox'
import { withReactFinalForm } from './withReactFinalForm'
import { withReactFinalFormToggle } from './withReactFinalFormToggle'

// Simple form components
export const DateCheckbox = withReactFinalForm(DATE_CHECKBOX)
export const SelectCheckbox = withReactFinalForm(SELECT_CHECKBOX)
export const FileUploadCheckbox = withReactFinalForm(FILE_UPLOAD_CHECKBOX)
export const Async = withReactFinalForm(ASYNC)
export const RichTextEditor = withReactFinalForm(RICH_TEXT_EDITOR)
export const DatePicker = withReactFinalForm(KeyboardDatePicker, {
  autoOk: true,
  variant: 'inline',
  format: 'dd-MM-yyyy',
  invalidDateMessage: 'Ongeldige datum (gebruik dag-maand-jaar)'
})

// Toggles
export const Checkbox = withReactFinalFormToggle(CHECKBOX)

export { Field, Select, SingleSelect }
